import React from 'react';
// template components
import AssistiveText from '@nmx/template/dist/componentLibrary/components/AssistiveText';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
// native components
import ClaimsInfoModule from '../claimsInfoModule';
// styles
import {
  ColStyled,
  SectionContainerStyled,
} from './styles';

export default () => {
  return (
    <SectionContainerStyled
      id='claims-info'
      backgroundVariant='lightA'
      themeType='lightTheme'
      disableBottomPadding>
      <AssistiveText component='h2'>
        Claims Information
      </AssistiveText>
      <Row align='center'>
        <ColStyled medium={4}>
          <ClaimsInfoModule dataOption='death' />
        </ColStyled>
        <ColStyled medium={4}>
          <ClaimsInfoModule dataOption='disability' />
        </ColStyled>
        <ColStyled medium={4}>
          <ClaimsInfoModule dataOption='ltc' />
        </ColStyled>
      </Row>
    </SectionContainerStyled>
  );
};
